import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { fetchPrincipal } from "../../../../services/InventoryAPI";
import { useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

const ModalPrincipalFilter = ({
  open,
  setOpen,
  listId,
  setListId,
  setType,
  offset,
}) => {
  const { status } = useParams();
  const [tempArr, setTempArr] = useState([]);

  const {
    mutate: mutatePrincipals,
    data: principals,
    isLoading,
  } = useMutation({
    mutationFn: fetchPrincipal,
  });

  const handleSelectList = useCallback(
    (selectedId) => {
      var temp = [...tempArr];
      const index = temp.findIndex((id) => id === selectedId);
      setTempArr(
        index < 0
          ? [...tempArr, selectedId]
          : [...tempArr.slice(0, index), ...tempArr.slice(index + 1)]
      );
    },
    [tempArr]
  );

  useEffect(() => {
    mutatePrincipals({
      status: Number(status),
      limit: 10000,
      name: "",
      offset: offset,
    });
  }, [offset]);

  useEffect(() => {
    if (open) setTempArr(listId);
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Principal
        {tempArr.length > 0 ? (
          <Button
            variant="contained"
            sx={{ marginLeft: 1 }}
            onClick={() => {
              setOpen(false);
              setListId(tempArr);
              setType("principal");
            }}
          >
            Cari
          </Button>
        ) : null}
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table sx={{ width: "100%" }} aria-label="simple table">
            <TableBody>
              {principals && principals !== undefined && !isLoading ? (
                <>
                  {principals.map((category) => (
                    <TableRow
                      key={category.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="label"
                        sx={{ paddingY: 0 }}
                      >
                        <FormControlLabel
                          sx={{ width: "100%" }}
                          control={
                            <Checkbox
                              checked={tempArr.includes(category.id)}
                              onChange={() => {
                                handleSelectList(category.id);
                              }}
                            />
                          }
                          label={category.name}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              ) : isLoading ? (
                <CircularProgress size={20} />
              ) : (
                "Tidak ada principal"
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default ModalPrincipalFilter;
